import '../Styles/ContactPageStyles.css'
import { useEffect, useState } from 'react'
import { CHARACTER_VALIDATION, CompanyInformation, ContactFormData, DESCRIPTION_MIN_VALIDATION, DESCRIPTION_SPACE_VALIDATION, NUMBER_NOT_ALLOWED_EMAIL, SPACE_EMAIL_VALIDATION, VALIDATE_DESCRIPTION, VALIDATE_EMAIL, VALIDATE_EMAIL_INVALID, VALIDATE_NAME, VALIDATE_NAME_LENGTH, VALIDATE_NAME_MAX, VALIDATE_NAME_NUMBERS, VALIDATE_WHITE_SPACE,Heading } from '../Model/ContactPageModel'
import OpenInfoView from './../../../components/ContactPage/OpenInfoView/View/OpenInfoView';
import ClosedInfoView from './../../../components/ContactPage/ClosedInfoView/View/ClosedInfoView';
import TextFieldView from './../../../components/ContactPage/TextFieldView/View/TextFieldView';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import toast from 'react-hot-toast';
import axios from 'axios';
import SpinnerLoader from '../../../../assets/loader/SpinnerLoader';
import { ApiRequestMethod } from '../../../../helper/api_calls';
import { API_URL } from './../../../../helper/api_url';



const ContactPageView = () => {
    const [isExpand, setIsExpand] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [isShowLoader, setShowLoader] = useState(false)

    const formik = useFormik({
        initialValues: {
            name: '',
            email: '',
            description: ''
        },
        validationSchema: Yup.object({
            name: Yup.string()
                .required(VALIDATE_NAME)
                .test("notEmpty", VALIDATE_NAME_LENGTH, (value) => value.trim() !== "")
                .matches(/^[A-Za-z\s]+$/, VALIDATE_NAME_NUMBERS)
                .matches(/^(?!.*\s{2,}).*$/, "Name should not contain consecutive spaces.")
                .min(3, VALIDATE_NAME_LENGTH)
                .max(30, VALIDATE_NAME_MAX),
                
            email: Yup.string().email(VALIDATE_EMAIL_INVALID).required(VALIDATE_EMAIL)
                .matches(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/, VALIDATE_EMAIL_INVALID).max(36, VALIDATE_EMAIL_INVALID)
                .test(
                    'no-extra-dots',
                    VALIDATE_EMAIL_INVALID,
                    (value) => value && /^(?!.*\.\.)(?=.*\.com$).*$/.test(value)
                )
                .test(
                    'no-starting-number',
                    NUMBER_NOT_ALLOWED_EMAIL,
                    (value) => !/^\d/.test(value)
                ).test(
                    'no-hyphen',
                    VALIDATE_EMAIL_INVALID,
                    (value) => !/\-/.test(value)
                ).test(
                    'no-leading-space',
                    SPACE_EMAIL_VALIDATION,
                    (value) => value && value.trim() === value
                ),
            description: Yup.string().min(26, DESCRIPTION_MIN_VALIDATION).max(100, CHARACTER_VALIDATION).required(VALIDATE_DESCRIPTION)
                .test(
                    'no-leading-space',
                    DESCRIPTION_SPACE_VALIDATION,
                    (value) => value && value.trim() === value
                ),
        }),
        onSubmit: async (values, { resetForm }) => {

            setShowLoader(true);
            try {
                const data = {
                    name: values.name,
                    email: values.email,
                    description: values.description
                };

                const payload = {
                    method: "post",
                    data: data,
                    url: API_URL?.contact_registration
                };

                const res = await ApiRequestMethod(payload)
                if (res?.status === 201) {
                    toast.dismiss()
                    toast.success("Form submitted successfully");
                    resetForm();
                }

            } catch (error) {
                console.error("API Error:", error);
                toast.error("Something went wrong");
            } finally {
                setShowLoader(false);
            }
        }

    });


    useEffect(() => {
        const handleResize = () => {
            const mobile = window.innerWidth <= 768;
            setIsMobile(mobile);
            setIsExpand(mobile);
        };

        handleResize();
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);


    function Expand() {
        setIsExpand(!isExpand)
    }

    if (isShowLoader) {
        return (
            <SpinnerLoader />
        )
    }

    return (
        <div className="contact-page-view-main-container" >
            <div className="contact-page-view-main-container-wrapup">
                <div className="contact-page-view-main-container-form-container" data-aos="fade-up">
                    <div className='contact-page-view-main-container-form-image-container'>
                        <span className='contact-page-main-heading'>{Heading}</span>
                    </div>
                    <form onSubmit={formik.handleSubmit} className='contact-page-view-main-container-main-form-container'>
                        <label className='contact-us-input-label-font'>Name <span style={{ color: '#C43838' }}>*</span></label>
                        <input
                            type="text"
                            name="name"
                            className="contact-page-text-field"
                            placeholder='Enter your name'
                            value={formik.values.name}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        />
                        {formik.touched.name && formik.errors.name && <div className="error-11">{formik.errors.name}</div>}

                        <label className='contact-us-input-label-font'>Email <span style={{ color: '#C43838' }}>*</span></label>
                        <input
                            type="email"
                            name="email"
                            className="contact-page-text-field"
                            placeholder='Enter your email'
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        />
                        {formik.touched.email && formik.errors.email && <div className="error-11">{formik.errors.email}</div>}

                        <label className='contact-us-input-label-font'>Description <span style={{ color: '#C43838' }}>*</span></label>
                        <textarea
                            className='contact-page-text-area-field'
                            name="description"
                            style={{ resize: "none" }}
                            rows='10'
                            placeholder='Please provide description (max 100 characters)'
                            value={formik.values.description}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        />
                        {formik.touched.description && formik.errors.description && <div className="error-11">{formik.errors.description}</div>}

                        {/* <label className='input-label-font-stylings'>Description</label>
                        <textarea className='contact-page-text-area-field' style={{ resize: "none" }} rows='10' columns placeholder='Please provide description (max 100 characters)' /> */}
                        <div class="contact-page-view-main-container-button-container">
                            <button class="contact-page-submit-button">
                                <span>Submit</span>
                            </button>
                        </div>
                    </form>

                </div>

                <div className="contact-page-view-main-container-contact-container">
                    {
                        isExpand ? (<OpenInfoView Expand={Expand} isMobile={isMobile} />) : (<ClosedInfoView Expand={Expand} />)
                    }

                </div>

                <div className='contact-page-mobile-view-main-container-contact-container'>
                    <div className='contact-page-mobile-view-main-container-contact-container-wrapup'>
                        <span className='contact-page-info-text'>Info</span>
                        {CompanyInformation?.map((value, index) => (
                            <div className='individual-contact-info' key={index} style={{ gap: "10px" }}>
                                <div className='individual-contact-info-svg-part'>
                                    {value?.icon}
                                </div>
                                <div className='individual-contact-info-content-part'>
                                    <span className='contact-page-info-text-sub'>{value?.details}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

            </div>
        </div>
    )
}

export default ContactPageView;